import { logoConfcooperative } from './logo-confcooperative';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

export const bold = false;
export const alignment = 'left';
export const fontSize = 10;
export const italics = false;

export const bold1 = false;
export const bold2 = false;
export const italics1 = false;
export const italics2 = false;
export const fontSize1 = 10;
export const fontSize2 = 10;

/**
 * format singolo
 * @param {any} valore
 * @param {any} bold
 * @param {any} alignment
 * @param {any} fontSize
 * @param {any} italics
 */
export function format(valore: any, bold?: any, alignment?: any, fontSize?: any, italics?: any) {
    return {
        text: valore,
        bold: bold,
        alignment: alignment,
        fontSize: fontSize,
        italics: italics,
    };
}

/**
 * AGGIUNGE BORDO ESTERNO ALLA TABELLA
 * @param {any} table
 */
export function fxTabellaEsternaBordo(table) {
    let colsTmp = [];
    let rowsTmp = [];

    colsTmp.push({ header: '', width: '100%' });

    rowsTmp.push([table]);

    return fxTabella(colsTmp, rowsTmp, true);
}

/**
 * Ogni funzione passa COLS, ROWS e BORDER qui
 * @param {any} cols
 * @param {any} rows
 * @param {any} border
 */
export function fxTabella(cols: any[], rows, border?: any) {
    let body = [];
    let tabCols = [];
    let tabW = [];
    let tabVal = [];
    let contaColsVuote = 0;
    let noBorders = 'noBorders';

    for (let col of cols) {
        if (col.header == '') contaColsVuote += 1;
        tabCols.push(col.header);
        tabW.push(col.width);
    }

    if (contaColsVuote != cols.length) {
        body.push(tabCols);
    }

    for (let row of rows) {
        body.push(row);
    }

    /* Fix per rows vuoto */
    if (rows.length === 0) {
        console.log('empty rows, logging cols:', cols);
        body.push({});
    }
    /* ****************** */

    if (border) {
        noBorders = '';
    }

    return {
        layout: noBorders,
        table: {
            widths: tabW,
            body: body,
        },
    };
}

/**
 * format doppio testo concatenato
 * @param {any} testo1
 * @param {any} bold1
 * @param {any} italics1
 * @param {any} fontSize1
 * @param {any} testo2
 * @param {any} bold2
 * @param {any} italics2
 * @param {any} fontSize2
 * @param {any} alignment
 */
export function doubleFormat(testo1, bold1, italics1, fontSize1, testo2, bold2?: any, italics2?: any, fontSize2?: any, alignment?: any) {
    return {
        text: [
            {
                text: testo1,
                bold: bold1,
                italics: italics1,
                fontSize: fontSize1,
            },
            {
                text: testo2,
                bold: bold2,
                italics: italics2,
                fontSize: fontSize2,
            },
        ],
        alignment: alignment,
    };
}

/**
 * CONTENUTO SUCCESSIVO VA AD UNA NUOVA PAGINA
 */
export function newPage() {
    return { text: ' ', pageBreak: 'before' };
}

/**
 * LINEA VUOTA
 */
export function lineaVuota() {
    return {
        text: '\n',
        fontSize: 10,
        alignment: 'left',
    };
}

/**
 * crea indentazione per il testo, intendazione in %
 * @param {any} indentazione
 * @param {any} testo
 */
export function Indent(indentazione, testo) {
    let colsTmp = [];
    let rowsTmp = [];

    colsTmp.push({ header: '', width: '' + indentazione + '%' });
    colsTmp.push({ header: '', width: '*' });
    rowsTmp.push([' ', testo]);

    return fxTabella(colsTmp, rowsTmp);
}

/**
 * crea spazio vuoto per facilitare calcolo altezza tabella
 */
export function empty() {
    return {
        text: ' ',
    };
}

//FUNZIONI PER CHECKBOX

/**
 * Singola
 * @param {any} siNo
 * @param {any} optVal
 */
export function checkSingolo(siNo, optVal?: any) {
    let defVal = 1;
    if (typeof optVal != 'undefined') {
        defVal = optVal;
    }

    if (siNo == defVal) {
        return [{ text: '[x]' }];
    } else {
        return [{ text: '[]' }];
    }
}

/**
 * singola per sottotabella
 * @param {any} siNo
 * @param {any} optVal
 */
export function checkSingoloInterno(siNo, optVal?: any) {
    let defVal = 1;
    if (typeof optVal != 'undefined') {
        defVal = optVal;
    }

    if (siNo == defVal) {
        return '[x]';
    } else {
        return '[]';
    }
}

/**
 * multipla
 * @param {any} siNo
 * @param {any} defVal
 */
export function checkSN(siNo, defVal) {
    if (siNo == defVal) {
        return [{ text: '[x] Si  [] No' }];
    } else if (siNo == 0 && !isNilOrEmpty(siNo)) {
        return [{ text: '[] Si  [x] No' }];
    } else {
        return [{ text: '[] Si  [] No' }];
    }
}

/**
 * multipla con N.A.
 * @param {any} siNo
 * @param {any} defVal
 */
export function checkSNA(siNo, defVal) {
    if (siNo == defVal) {
        return [{ text: '[x] Si  [] No  [] N.A.' }];
    } else if (siNo == 0 && !isNilOrEmpty(siNo)) {
        return [{ text: '[] Si  [x] No  [] N.A.' }];
    } else if (siNo == 'na') {
        return [{ text: '[] Si  [] No  [x] N.A.' }];
    } else {
        return [{ text: '[] Si  [] No  [] N.A.' }];
    }
}

export function tabellaCheck(testo, valore?: any, optVal?: any) {
    let colsTmp = [];
    let rowsTmp = [];

    colsTmp.push({ header: '', width: '80%' });
    colsTmp.push({ header: '', width: '20%' });

    let defVal = 1;
    if (typeof optVal != 'undefined') {
        defVal = optVal;
    }

    rowsTmp.push([testo, format(checkSN(valore, defVal), bold, 'center', fontSize, italics)]);
    return fxTabella(colsTmp, rowsTmp);
}

export function tabellaCheckSNA(testo, valore, optVal) {
    let colsTmp = [];
    let rowsTmp = [];

    colsTmp.push({ header: '', width: '80%' });
    colsTmp.push({ header: '', width: '20%' });

    let defVal = 1;
    if (typeof optVal != 'undefined') {
        defVal = optVal;
    }

    rowsTmp.push([testo, format(checkSNA(valore, defVal), bold, 'center', fontSize, italics)]);

    return fxTabella(colsTmp, rowsTmp);
}

/**
 * FIRMA DIGITALE
 * @param {any} base64
 */
export function getFirmaDigitale(base64) {
    if (base64 === '' || base64 === ' ' || typeof base64 === 'undefined') {
        return ' ';
    } else {
        return {
            fit: [180, 180],
            alignment: 'center',
            image: 'data:image/jpeg;base64,' + base64,
        };
    }
}

// *****************************************************************************************************************************************************************************************
// PARAMETRI NASCOSTI
// *****************************************************************************************************************************************************************************************

export function parametriNascosti(gruppo: string = '', md5: string = '', tipodoc: string = '', tipostampa: string = '') {
    return {
        text:
            '#gruppo#' +
            gruppo?.trim() +
            '#gruppo#' +
            '#md5#' +
            md5?.trim() +
            '#md5#' +
            '#tipodocumento#' +
            tipodoc?.trim() +
            '#tipodocumento#' +
            '#stampa#' +
            tipostampa?.trim() +
            '#stampa#',
        color: 'white',
        fontSize: 5,
    };
}

// *****************************************************************************************************************************************************************************************
//INTESTAZIONE LOGO CONFCOOPERATIVE
// *****************************************************************************************************************************************************************************************

let codiceQRBase64;

export function newQRCode(val) {
    // codiceQRBase64 = new QRious({
    //     background: '#fff',
    //     backgroundAlpha: 1,
    //     foreground: '#000',
    //     foregroundAlpha: 1,
    //     level: 'H',
    //     size: 100,
    //     value: val
    // })
}

export function logoConfImage() {
    return {
        fit: [220, 220],
        alignment: 'left',
        image: logoConfcooperative,
    };
}

export function QRCodeImage() {
    if (codiceQRBase64.image.currentSrc != '') {
        return {
            alignment: 'right',
            image: codiceQRBase64.image.currentSrc,
            background: 'white',
            width: 40,
            height: 40,
            margin: 5,
        };
    } else {
        return empty();
    }
}

export function intestazioneLogoConf() {
    let cols = [];
    let rows = [];

    if (codiceQRBase64 == '' || codiceQRBase64 == ' ' || typeof codiceQRBase64 == 'undefined') {
        cols.push({ header: '', width: '100%' });
        rows.push([logoConfImage()]);
    } else {
        cols.push({ header: '', width: '50%' });
        cols.push({ header: '', width: '50%' });

        rows.push([logoConfImage(), QRCodeImage()]);
    }
    return fxTabella(cols, rows);
}
